const BhVampClock = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11ZM6.375 3.875C6.375 3.66789 6.20711 3.5 6 3.5C5.79289 3.5 5.625 3.66789 5.625 3.875V6C5.625 6.09946 5.66451 6.19484 5.73484 6.26517L7.10983 7.64017C7.25628 7.78661 7.49372 7.78661 7.64017 7.64017C7.78661 7.49372 7.78661 7.25628 7.64017 7.10983L6.375 5.84467V3.875Z"
      fill="currentColor"
    />
  </svg>
)

export default BhVampClock
